import React from "react";
import { Layout, Typography, Image } from "antd";
import CommonSidebar from "../../components/CommonSidebar";
import beachImage from "../../assets/focus.jpg";

const { Paragraph } = Typography;
const { Content } = Layout;

const AboutPage = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ background: "#fff" }}>
        {/* Sidebar */}
        <CommonSidebar defaultSelectedKey="1" />

        {/* Main Content */}
        <Layout
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            padding: "20px 20px",
            flex: 1,
          }}
        >
          <Content
            style={{
              width: "100%",
              maxWidth: "100%",
            }}
          >
            {/* Image Section */}
            <div style={{ textAlign: "left", marginBottom: "30px" }}>
              <Image
                src={beachImage}
                alt="Family Playing Beach"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
                preview={false}
              />
            </div>

            {/* Text Section */}
            <Typography>
              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>“Yalla Nellab,”</strong> meaning “Let’s Play” in Arabic,
                began with a simple idea to reignite the joy of sports in
                everyday life. From the vibrant streets of Dubai to communities
                across the world, we are on a mission to make movement, play
                and active living an integral part of everyone’s journey.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                Our mission is to bring sports back into everyone’s life —
                anytime, anywhere. In a world where sports have increasingly
                become a luxury and many people are deprived of the opportunity
                or time to engage, we strive to create accessible spaces,
                experiences and opportunities where people of all ages and
                abilities can connect through play, develop skills and embrace
                the transformative power of movement.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                We believe sports are more than games — they are tools for
                growth, connection and empowerment. That’s why we take a
                holistic approach: supporting and hosting community programs,
                organizing workshops and seminars and using our media
                platforms to amplify the impact of our initiatives.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                At the heart of Yalla NelLab is a commitment to community. We
                understand that movement is one of the most valuable resources
                for a healthy and fulfilling life. By encouraging play,
                activity and engagement, we create positive change that goes
                beyond the field.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                Yalla NelLab isn’t just about sports. It’s about creating
                opportunities, sparking joy and leaving a lasting impact — one
                game, one movement and one community at a time.
              </Paragraph>
            </Typography>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AboutPage;